import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useSite from '~/client/hooks/useSite';
import Translate from '~/client/shared/i18n/Translate';
import Img from '~/client/shared/images/Img';
import SigninButton from '~/client/shared/SigninButton';
import SignupButton from '~/client/shared/SignupButton';
import getCdnImg from '~/shared/cdn/getCdnImg';

const NoFunModeMessage: FC = () => {
  const { site, isBridgeSite } = useSite();
  const image = getCdnImg(`character/${site}`, '.png');
  const isLoggedIn = useIsLoggedIn();
  const messageId = isLoggedIn
    ? 'game.no_fun_mode_logged_in'
    : 'game.no_fun_mode_logged_out';

  return (
    <div className="absolute h-full w-full bg-popo/80 text-center backdrop-blur-[20px] [&_span]:text-goten">
      <Img
        src={image}
        width={200}
        height={173}
        className="mx-auto mt-[177px]"
      />
      <p className="mt-6 text-moon-18 font-medium">
        <Translate id={messageId} />
      </p>
      {isBridgeSite && (
        <p className="mt-6 text-moon-18 font-medium">
          <div className="flex items-center justify-center">
            <div className="inline-container">
              <SigninButton />
              <SignupButton pulse={false} />
            </div>
          </div>
        </p>
      )}
    </div>
  );
};

export default NoFunModeMessage;
